import Vue from 'vue'
import Vuex from 'vuex'
import error from './modules/error'
import loading from './modules/loading'
import patron from './modules/patron'

Vue.use( Vuex )

export default new Vuex.Store( {
	modules: {
		error,
		loading,
		patron
	},
	state: {
		beta: false
	},
	getters: {
		beta( state, getters ) {
			return state.beta;
		}
	},
	mutations: {
		setBeta( state, data ) {
			state.beta = data;
		}
	},
	actions: {
        enableBeta( context, payload ) {
            context.commit( 'setBeta', true );
        }
	}
} )
